var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilesPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.0191 36.46C74.1943 36.46 71.7771 36.4196 68.7677 36.4196C61.4282 36.4196 55.3934 30.345 55.3934 22.9366V9.93862C55.3934 8.91608 54.577 8.0835 53.5645 8.0835H32.1865C22.2098 8.0835 14.146 16.2719 14.146 26.3074V69.8563C14.146 80.3849 22.594 88.9168 33.0189 88.9168H64.8539C74.7945 88.9168 82.8543 80.781 82.8543 70.7374V38.2788C82.8543 37.2522 82.042 36.4237 81.0255 36.4277C79.3167 36.4398 77.2677 36.46 76.0191 36.46Z",
    fill: "#136BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.0062 10.3762C63.7977 9.11925 61.688 9.98417 61.688 11.7261V22.384C61.688 26.8541 65.3699 30.532 69.84 30.532C72.6571 30.5643 76.5694 30.5724 79.8916 30.5643C81.5932 30.5603 82.4581 28.5273 81.2779 27.2987C77.014 22.865 69.3793 14.919 65.0062 10.3762Z",
    fill: "#136BFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2697 46.0249H49.9507C51.6119 46.0249 52.9618 44.679 52.9618 43.0179C52.9618 41.3568 51.6119 40.0068 49.9507 40.0068H36.2697C34.6086 40.0068 33.2627 41.3568 33.2627 43.0179C33.2627 44.679 34.6086 46.0249 36.2697 46.0249ZM36.2702 66.2098H58.273C59.9341 66.2098 61.2841 64.8639 61.2841 63.2028C61.2841 61.5416 59.9341 60.1917 58.273 60.1917H36.2702C34.6091 60.1917 33.2632 61.5416 33.2632 63.2028C33.2632 64.8639 34.6091 66.2098 36.2702 66.2098Z",
    fill: "#136BFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesPlaceholder);
export default __webpack_public_path__ + "static/media/files-placeholder.6283a7e27b9254b7cc613e82c7a61cf6.svg";
export { ForwardRef as ReactComponent };